import axios from 'axios';

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

// Calcola il Codice Fiscale dai dati anagrafici del cliente (stessi controlli del pulsante
// "Calcola CF" di Anagrafica Clienti). Usato dai form "Nuovo cliente" dei Servizi.
// Ritorna il CF calcolato; lancia un Error con messaggio da mostrare all'operatore.
export const calcolaCodiceFiscale = async (client) => {
  if (!client.last_name || !client.first_name || !client.gender || !client.birth_date) {
    throw new Error('Compila Cognome, Nome, Sesso e Data di nascita');
  }
  if (!client.birth_abroad && (!client.birth_comune || !client.birth_provincia)) {
    throw new Error('Compila Comune e Provincia di nascita');
  }
  if (client.birth_abroad && !client.birth_country) {
    throw new Error('Seleziona la Nazione di nascita');
  }
  try {
    const res = await axios.post(`${API}/calculate-fiscal-code`, {
      surname: client.last_name,
      name: client.first_name,
      birth_date: client.birth_date,
      gender: client.gender,
      birth_abroad: client.birth_abroad,
      birth_comune: client.birth_comune,
      birth_provincia: client.birth_provincia,
      birth_country: client.birth_country,
    });
    return res.data.fiscal_code;
  } catch (error) {
    throw new Error(error.response?.data?.detail || 'Errore nel calcolo del Codice Fiscale');
  }
};
